module.exports = __webpack_public_path__ + "img/graduation-1024x768.5ce4a73e.jpeg";